import { IconX } from '@tabler/icons-react';
import { useContinueConversationExecution } from './hooks';
import { IconButton, useTheme } from '@mui/material';

export const CsatCloseButton = () => {
  const theme = useTheme();
  const continueConversationExecution = useContinueConversationExecution();

  return (
    <IconButton aria-label='Close CSAT' onClick={continueConversationExecution}>
      <IconX color={theme.palette.colors.grey[700]} size={20} />
    </IconButton>
  );
};
